import React from 'react';
import './TooltipGroup.scss';
import h from 'react-hyperscript';
import Tooltip from '@material-ui/core/Tooltip';
import Image from 'Components/Image/Image';

function TooltipGroup(props) {
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const toggleTooltipOpen = () => {
    setOpen(!open);
  };

  const placement = props.placement;
  const title = props.title;

  return (
    h('div', null, h('div', {
      className: `tooltip-container flex flex--align-start${
        props.className ? ' ' + props.className : ''
      }`,
    }, [
      props.children,
      h(Tooltip, {
        'title': h('span', {
          'dangerouslySetInnerHTML': {'__html': title},
        }, null),
        'aria-label': title,
        'className': 'tooltip-group',
        'placement': placement ? placement : 'top',
        open,
        'tabIndex': 0,
        'enterTouchDelay': 0,
        'leaveTouchDelay': 20000,
        'onClose': handleTooltipClose,
        'onMouseEnter': handleTooltipOpen,
        'onMouseLeave': handleTooltipClose,
        'onKeyUp': (e) => {
          const key = e.key;

          if (key === 'Escape') {
            handleTooltipClose();
          }

          if (key === 'Tab') {
            toggleTooltipOpen();
          }
        },
      }, h('div', {
        className: 'tooltip-icon flex',
      }, h(Image, {
        key: 'tooltip-trigger__key',
        src: 'https://storage.googleapis.com/sherlock-dev-assets/icons/info-small.svg',
        alt: 'Tooltip icon',
      }, null
      )
      )),
    ]))
  );
}

export default TooltipGroup;
